var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{attrs:{"title":"商户进件","left-text":"返回","left-arrow":"","fixed":""},on:{"click-left":_vm.onClickLeft}}),_c('div',{staticStyle:{"margin-top":"1.5rem"}},[_c('van-empty',{attrs:{"description":"正在开发"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }